import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { FaStar } from "react-icons/fa";
import { dishes } from "../data/dishes";
import { business } from "../data/business";
import { useTheme, useDocumentTitle } from "../hooks/useSite";
import { Guest } from "../illustrations";

// Existing EmailJS feedback integration (same service and template).
const EMAILJS = { service: "service_zleknzbbn", template: "template_962ouwi", key: "JiNk4fjq66o6LTiKN" };

export default function FeedbackPage() {
  useTheme(dishes[6]);
  useDocumentTitle("Feedback");
  const form = useRef(null);
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    const f = form.current;
    if (!f.name.value.trim() || !f.email.value.trim() || !f.message.value.trim()) {
      setError("Please fill in your name, e-mail and message.");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email.value.trim())) {
      setError("Please enter a valid e-mail.");
      return;
    }
    setError("");
    setStatus("sending");
    try {
      await emailjs.sendForm(EMAILJS.service, EMAILJS.template, f, EMAILJS.key);
      setStatus("sent");
      f.reset();
      setRating(0);
    } catch (err) {
      setStatus("error");
    }
  };

  return (
    <>
      <section className="ro-education-intro ro-form-intro">
        <div className="ro-container ro-split">
          <div>
            <h1>
              <strong className="ro-italic">Love to hear</strong>
              <br />
              <span className="ro-outline">from you.</span>
            </h1>
            <p className="ro-education-intro__sub">(How was your RollOver?)</p>
          </div>
          <Guest className="ro-form-intro__figure" />
        </div>
      </section>
      <section className="ro-section">
        <div className="ro-container ro-container--narrow">
          {status === "sent" ? (
            <div className="ro-form-result" role="status">
              <h2>
                Thank <span className="ro-outline">you.</span>
              </h2>
              <p>Your feedback has been emailed to the RollOver team.</p>
              <button type="button" className="ro-pill ro-pill--solid" onClick={() => setStatus("idle")}>
                Send more feedback
              </button>
            </div>
          ) : (
            <form ref={form} className="ro-form" onSubmit={submit} noValidate>
              <div className="ro-form__grid">
                <label className="ro-field">
                  <span className="ro-field__label">Name</span>
                  <input type="text" name="name" autoComplete="name" required />
                </label>
                <label className="ro-field">
                  <span className="ro-field__label">E-mail</span>
                  <input type="email" name="email" autoComplete="email" required />
                </label>
              </div>
              <label className="ro-field">
                <span className="ro-field__label">Subject</span>
                <input type="text" name="subject" />
              </label>
              <label className="ro-field">
                <span className="ro-field__label">Message</span>
                <textarea name="message" rows="5" required />
              </label>
              <fieldset className="ro-field ro-rating">
                <legend className="ro-field__label">Rate your experience</legend>
                <div className="ro-rating__stars" onMouseLeave={() => setHover(0)}>
                  {[1, 2, 3, 4, 5].map((n) => (
                    <button key={n} type="button" aria-label={`${n} star${n > 1 ? "s" : ""}`} aria-pressed={rating === n} className={n <= (hover || rating) ? "is-on" : ""} onClick={() => setRating(n)} onMouseEnter={() => setHover(n)}>
                      <FaStar aria-hidden="true" />
                    </button>
                  ))}
                </div>
                <input type="hidden" name="rating" value={rating ? `${rating}/5` : "not rated"} />
              </fieldset>
              <div className="ro-form__actions">
                <button type="submit" className="ro-pill ro-pill--solid" disabled={status === "sending"}>
                  {status === "sending" ? "Sending…" : "Send feedback"}
                </button>
                <p className="ro-small" role="status" aria-live="polite">
                  {error || (status === "error" ? "Could not send. Please try again or message " + business.phone.display + " on WhatsApp." : "Sends an email to the café.")}
                </p>
              </div>
            </form>
          )}
        </div>
      </section>
    </>
  );
}
